/* ADD GROUPS */
export const LIST_REPORT_SURVEY = "LIST_REPORT_SURVEY"
export const LIST_REPORT_SURVEY_SUCCESS = "LIST_REPORT_SURVEY_SUCCESS"
export const LIST_REPORT_SURVEY_CLEAN = "LIST_REPORT_SURVEY_CLEAN"
export const LIST_REPORT_SURVEY_ERROR = "LIST_REPORT_SURVEY_ERROR"
